<script setup lang="ts">
import Drawer from '@uiKit/elements/Drawer.vue'
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'
import AskSliceyDrawerContainer from '../containers/AskSliceyDrawerContainer.vue'

interface Props {
  open: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <Drawer
    :modelValue="open"
    position="right"
    width="520px"
    @update:modelValue="(v) => !v && emit('close')"
  >
    <template #header>
      <Box direction="col" gap="1" class="slicey-drawer__header">
        <Box align="center" gap="2">
          <Box align="center" justify="center" class="slicey-drawer__sparkle">
            <PiIcon name="sparkles" />
          </Box>
          <Text type="heading" weight="semibold">Slicey</Text>
        </Box>
        <Box align="center" gap="2">
          <Box class="slicey-drawer__dot" />
          <Text type="caption" color="muted">Verified secure session</Text>
        </Box>
      </Box>
    </template>

    <AskSliceyDrawerContainer />
  </Drawer>
</template>

<style scoped>
.slicey-drawer__header {
  flex: 1;
}

.slicey-drawer__sparkle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--p-primary-50);
  color: var(--p-primary-600);
  font-size: 0.85rem;
}

.slicey-drawer__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--p-success-500);
  box-shadow: 0 0 0 3px rgba(47, 196, 141, 0.18);
}
</style>
